import api from '../api';
import {
  ComplianceChangelogCreate,
  ComplianceChangelogEntry,
  ComplianceChangelogUpdate,
} from '../../types/compliance';

const BASE = '/compliance/changelog';

export const changelogService = {
  async list(limit = 50, offset = 0): Promise<ComplianceChangelogEntry[]> {
    const { data } = await api.get<ComplianceChangelogEntry[]>(BASE, {
      params: { limit, offset },
    });
    return data;
  },

  async get(id: string): Promise<ComplianceChangelogEntry> {
    const { data } = await api.get<ComplianceChangelogEntry>(`${BASE}/${id}`);
    return data;
  },

  async create(
    body: ComplianceChangelogCreate,
  ): Promise<ComplianceChangelogEntry> {
    const { data } = await api.post<ComplianceChangelogEntry>(BASE, body);
    return data;
  },

  async update(
    id: string,
    body: ComplianceChangelogUpdate,
  ): Promise<ComplianceChangelogEntry> {
    const { data } = await api.patch<ComplianceChangelogEntry>(
      `${BASE}/${id}`,
      body,
    );
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`${BASE}/${id}`);
  },
};

export default changelogService;
